import React from "react";
import { EntityEditProvider } from "@/contexts/EntityEditContext";
import type { EntityEditProviderProps } from "@/types/contexts/entityEdit";
import { BillingItemType } from "@/types/db/billing_items";
import { billingItemService } from "@/services/billingItemService";

interface BillingItemEditProviderProps extends Omit<EntityEditProviderProps<BillingItemType>, "onSave" | "entityName"> {
  children: React.ReactNode;
}

export function BillingItemEditProvider({
  children,
  entityData,
  loading,
  onSaveSuccess,
}: BillingItemEditProviderProps) {
  const handleSave = async (formData: Partial<BillingItemType>): Promise<BillingItemType> => {
    if (!entityData?.id) {
      throw new Error("No billing item ID available");
    }

    // Clean the data - remove read-only fields before sending to database
    const { id, created_at, updated_at, client, project, ...cleanFormData } = formData as any;

    // Use saveRowPatches for update
    await billingItemService.saveRowPatches([{ id: entityData.id, ...cleanFormData }]);

    // Return the updated data (fetch fresh data)
    const updated = await billingItemService.getBillingItemById(entityData.id);
    return updated;
  };

  return (
    <EntityEditProvider
      entityData={entityData}
      loading={loading}
      onSave={handleSave}
      onSaveSuccess={onSaveSuccess}
      entityName="Billing Item"
    >
      {children}
    </EntityEditProvider>
  );
}
